import { getName } from 'country-list'
import moment from 'moment'

const LIST_FILTER_OPERATOR = {
    'is': 'equal',
    'is_not': 'not equal',
}

const DATE_FILTER_OPERATOR = {
    'lt': 'before' ,
    'gt': 'after',
    'is' : 'on',
}

const FILTER_PIVOT = {
    platform: 'Platform',
    browser: 'Browser',
    country_iso: 'Geo Location',
    'first-seen': 'Subscription Date',
    'last-seen': 'Last Website Visit',
    'url-visited': 'URL\'s Visited',
}

const  SegmentModal = ({segmentDetails, onClose}) => {

    const getRows = () => {
        const data = [];
        segmentDetails.rules[0].filters.forEach(({name, value, inner_operator}) => {
            const existIndex = data.findIndex(({name: label}) => label === name);
            if(existIndex > -1) {
                data[existIndex].values.push(name === 'country_iso' ? getName(value) : value);
            } else {
                data.push({
                    name: name,
                    label: FILTER_PIVOT[name],
                    values: [name === 'country_iso' ? getName(value) : value],
                    operator: LIST_FILTER_OPERATOR[inner_operator],
                })
            }
        });
        segmentDetails.rules[0].events.forEach(({category, value, inner_operator}) => {
            if(category === 'url-visited') {
                data.push({
                    name: category,
                    label: FILTER_PIVOT[category],
                    values: [value],
                    operator: LIST_FILTER_OPERATOR[inner_operator],
                })
            } else {
                const existIndex = data.findIndex(({name}) => name === category);
                if(existIndex > -1) {
                    data[existIndex].values.push(moment(value).format('DD/MM/YYYY'));
                    data[existIndex].operator = 'between';
                } else {
                    data.push({
                        name: category,
                        label: FILTER_PIVOT[category],
                        values: [moment(value).format('DD/MM/YYYY')],
                        operator: DATE_FILTER_OPERATOR[inner_operator],
                    })
                }
            }

        });
        return data;
    }

    return <div className="modal modal-center fade show" tabindex="-1">
    <div className="modal-dialog">
        <div  className="modal-content">
            <div style={{borderBottom: 'none'}} className="modal-header d-flex align-items-center">
                <label className="form-label text-dark h4 medium mb-0 word-wrap">{segmentDetails.title}</label>
                <i onClick={() => onClose()} className="btn btn-neutral icon icon-close"></i>
            </div>
            <div className="modal-body">
                <table className="table table-hover map-table full-width">
                        <colgroup width="100%">
                            <col width="40%"/>
                            <col width="20%"/>
                            <col width="40%"/>
                        </colgroup>
                        <tbody>
                            {
                                getRows().map(({label, values, operator}, index) =>  <tr key={index} >
                                <td className="titleCase">{label}</td>
                                <td>{operator}</td>
                                <td><strong className={label !== 'URL\'s Visited' && 'titleCase'}>{values.join(', ')}</strong></td>
                                {/* <td>{subscribersDetail.count}</td> */}
                            </tr>)
                            }
                        </tbody>
                    </table>
            </div>                    
        </div>
    </div>
</div>
}
export default SegmentModal;